$(document).ready(function () {
	clickDropdownMenu();
	$("[data-fancybox]").fancybox({
		afterLoad: function () {
			console.log("la");
			setTimeout(() => {
				$(".ytp-button").trigger("click");
				var vid = document.getElementById("video");
				function playVid() {
					vid.play();
					console.log('playvideorun')
				}
				playVid()
			}, 2500);
		},
	});
});
/*==================== cick ====================*/
function clickDropdownMenu() {
	$(".list-category-menu-2 li .menu-title .icon").click(function () {
		$(this).parent().next().slideToggle();
		$(this).parent().parent().toggleClass("active");
	});
	$(".tool-mb-menu").click(function () {
		$(this).toggleClass("active");
		$(".sidebar-category").toggleClass("active");
	});
}
